import React, { useState, useRef } from "react";

function BMIPercentageCal() {
    const [result, setResult] = useState(0);
    const prevRef = useRef(0);
    const newRef = useRef(0);

    function computePercent() {
        const prev = prevRef.current.value;
        const newVal = newRef.current.value;
        if (prev && newVal) {
            const lost = prev - newVal;
            const inPercent = Math.round((lost / prev) * 100);
            setResult(inPercent);
        }
    }
    return (
        <>
            <div className="row">
                <div className="col-4 bg-primary pl-5">
                    <h5>WeightLoss Percentage Calculator</h5>
                </div>
                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                <strong>Previous Weight (kgs)</strong>
                            </td>
                            <td>
                                <div className="form-group">
                                    <input
                                        type="number"
                                        className="form-control input-height"
                                        id="pre-weight-id"
                                        name="pre-weight-id"
                                        required
                                        min="0"
                                        ref={prevRef}
                                        onChange={computePercent}
                                        aria-describedby="pre-weight-id"
                                        placeholder="enter previous weight"
                                    />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                <strong>New Weight (kgs)</strong>
                            </td>
                            <td>
                                <div className="form-group">
                                    <input
                                        type="number"
                                        className="form-control input-height"
                                        id="new-weight-id"
                                        name="new-weight-id"
                                        required
                                        min="0"
                                        ref={newRef}
                                        onChange={computePercent}
                                        aria-describedby="new-weight-id"
                                        placeholder="enter new weight"
                                    />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                <strong>Change Percentage</strong>
                            </td>
                            <td style={{ width: "60%", backgroundColor: "aliceblue" }}>
                                <strong className="text-primary">{result}%</strong>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    );
}

export default BMIPercentageCal;
